var _circle, _circle2, _circle3, _circle4, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _path16, _path17, _g2, _ellipse2, _path18, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path19, _g3, _ellipse7, _path20, _path21, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#534766"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_399_475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 78,
    height: 78
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    fill: "#534766"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.5,
    stroke: "white",
    strokeOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_399_475)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2558 73.4252C51.3734 73.5791 48.3843 73.874 47 74.0023L52.2558 63.551C53.6055 63.2432 54.6783 63.4227 55.046 63.551C56.6465 64.5127 60.0942 66.5902 61.0805 67.2057C62.0668 67.8213 63.3329 68.6753 63.3545 68.8035C64.5874 71.4324 62.6778 74.1707 62.1587 74.9401C61.3243 76.1769 59.1988 77.08 57.6415 76.4388C56.3956 75.9258 53.532 74.216 52.2558 73.4252Z",
    fill: "#714BAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6491 73.3399C56.6543 75.1306 56.711 76.0047 56.8637 76.2179C57.8454 76.7295 58.958 76.8574 60.0051 76.2179C61.0523 75.5783 62.8801 74.8144 63.5345 72.2563C64.0581 70.2097 63.6724 68.823 62.4314 68.2736C62.1042 68.2097 60.9214 68.991 60.725 69.2468C60.5287 69.5027 58.8925 71.1015 57.6491 73.3399Z",
    fill: "#312A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_399_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.569 68.9682C59.4998 71.8682 57.7065 74.6812 58.2784 77.0336C58.6597 77.0336 59.651 77.5521 60.5661 79.626C61.4813 81.7 62.4726 82.2185 62.8539 82.2185C64.913 82.4489 65.0464 80.5862 64.8558 79.626C65.5421 79.8565 66.5716 80.0101 67.0006 80.0581C70.7183 80.2021 72.4341 75.8814 70.8613 73.1449C69.603 70.9557 65.4755 69.4483 63.569 68.9682Z",
    fill: "#BE9CF4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4117 59.1904C44.4699 59.1904 32.9155 60.9376 29.0779 59.9648C29.3282 59.8655 28.8902 59.9409 25.1361 61.0369C21.3819 62.1329 20.2349 65.9409 20.1306 67.708C19.8177 71.7384 20.1896 80.2526 20.4603 82.238C21.5079 89.9206 25.369 93.2258 26.7455 93.7619C28.122 94.2979 35.7102 90.4612 39.2767 91.1164C42.1298 91.6405 44.303 91.0171 45.033 90.6398C47.0978 90.1633 50.2888 87.6617 54.2932 85.16C57.4967 83.1587 58.2141 80.7126 58.1724 79.7398C57.822 71.115 57.2965 66.9932 55.9199 64.0151C54.5434 61.0369 49.8508 59.3096 48.4117 59.1904Z",
    fill: "#BE9CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5398 60.1435V58.0123L48.3969 57.7937V59.4331C43.6459 62.4059 33.8459 61.1454 29.5398 60.1435Z",
    fill: "#312A3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2356 11.7333C34.142 12.32 33.6945 14.2825 33.7324 15.1905L41.4128 14.7714V11C41.0145 11.0524 38.8527 11 36.2356 11.7333Z",
    fill: "#714BAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6032 15.3839C45.6032 17.6965 43.5495 19.381 41.5468 19.381C39.5441 19.381 37.9207 17.5062 37.9207 15.1936C37.9207 12.8809 39.5441 11.0062 41.5468 11.0062C43.4521 10.8793 45.4188 12.7192 45.6032 15.3839Z",
    fill: "#BE9CF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28564 23.9403C11.0787 18.036 17.4231 16.1126 20.3712 15.8889L21.1587 57.7928C17.3423 57.8538 13.8289 54.5601 12.0116 52.5472C10.5578 50.9369 10.1135 48.1759 10.0731 46.9966C9.78237 37.5301 9.42699 27.6814 9.28564 23.9403Z",
    fill: "#714BAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1588 14.5438C46.4132 14.2495 27.5813 15.2797 19.6335 15.8316C14.1732 16.9967 12.7778 20.0015 12.7778 24.4781C12.7778 28.9547 13.4452 44.2241 13.7485 50.9696C13.9912 56.3661 18.8246 57.8787 21.2109 57.9604C35.893 59.1869 48.4517 58.0218 56.9454 57.1632C65.4392 56.3047 66.6526 53.5452 67.0773 49.3139C67.502 45.0826 67.2593 22.0865 65.2572 18.2232C63.6555 15.1325 59.8576 14.4825 58.1588 14.5438Z",
    fill: "#BE9CF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80759 31.511C5.86332 29.2696 9.54642 28.5432 11.381 28.4602L9.49997 44.5237C9.33741 44.5029 8.71969 44.3245 7.54927 43.7766C6.37886 43.2287 5.99337 42.1785 5.94693 41.7219C5.87726 39.2522 5.75186 33.7524 5.80759 31.511Z",
    fill: "#714BAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3811 45.2221L11.136 28.4602C9.05824 28.4602 8.57146 30.1469 8.5878 30.9903C8.62047 34.1318 8.69561 40.883 8.73481 42.7553C8.77401 44.6275 10.5153 45.1799 11.3811 45.2221Z",
    fill: "#BE9CF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5873 60.9366C29.1829 59.6713 27.1152 59.8022 26.3887 59.9644C22.466 60.5484 20.7185 63.8982 20.3351 65.5001C19.9961 67.836 19.7499 71.6237 19.6692 73.2256L20.3348 82.5872C20.3832 85.5557 24.835 93.5635 26.3887 94.111C28.8332 95.5034 37.8907 91.1099 40.2516 91.2924C42.1404 91.4384 43.6618 90.9072 44.1865 90.6233C45.4457 90.5259 52.8244 86.1538 55.7302 83.9842C57.3284 82.5729 58.1746 81.1905 58.1746 80.1429C56.6007 81.5015 50.8213 84.7348 45.8815 85.7568C40.9417 86.7788 37.1239 85.6554 35.8325 84.966C22.2723 81.4986 31.1507 68.3015 31.635 67.5715C32.1193 66.8415 32.3429 62.5182 30.5873 60.9366Z",
    fill: "#714BAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.481 21.5314C20.1432 19.5466 22.9059 19.2867 24.0794 19.4048L25.3492 54.9667C24.5989 55.0652 22.5789 55.0022 20.5011 53.9625C18.4233 52.9228 17.7885 50.7726 17.7307 49.8274C17.5383 43.3687 17.1189 29.7071 16.9804 26.7299C16.8419 23.7526 17.9231 22.0237 18.481 21.5314Z",
    fill: "#312A3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0893 17.4331C52.6138 16.8859 32.6718 17.9928 23.5102 18.6146C18.7382 19.7961 18.4965 23.7136 18.3757 24.9573C18.2791 25.9522 18.859 42.5344 19.161 50.7011C19.9825 54.5814 23.8123 55.8416 25.6244 55.9867C42.8401 57.1682 54.136 55.4892 59.5725 54.8052C63.9218 54.258 65.3715 50.8877 65.5527 49.2709C66.338 42.2442 65.4319 28.0664 64.7674 22.9674C64.2359 18.8882 60.7605 17.5782 59.0893 17.4331Z",
    fill: "#9C8BB8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6757 77.2522C67.8177 73.2075 62.1869 79.5617 59.9787 83.2444C56.2985 92.7945 62.923 95.7906 63.659 95.7906C67.9281 97.2887 71.1298 94.4798 72.3075 91.4837C75.5461 83.2444 74.0251 78.7503 72.6757 77.2522Z",
    fill: "#545258"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6639 20.112C56.3294 20.017 50.9298 20.1516 48.3967 20.2309L57.2932 52.9047C59.369 52.6671 60.4234 52.3701 60.6912 52.2513C63.7555 51.1582 64.4804 48.5482 64.4598 47.3799C64.4186 42.5085 64.2868 31.9697 64.0891 28.7855C63.8914 25.6013 63.3477 23.8151 63.1006 23.32C61.4325 20.7061 59.332 20.2309 57.6639 20.112Z",
    fill: "#463F52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.785,
    cy: 66.8004,
    rx: 5.18142,
    ry: 5.10205,
    transform: "rotate(-28.1783 25.785 66.8004)",
    fill: "#312A3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5539 63.213C30.8691 64.9903 30.5187 68.446 29.8041 69.9517L27.0952 74.5554C23.8089 80.0352 21.2983 82.6146 19.5694 83.7994C17.8406 84.9843 12.7924 84.3919 12.17 80.0228C11.6721 76.5275 13.4761 74.5554 15.2222 72.8095C17.3174 69.6667 18.7142 68.2696 19.7769 66.3232C21.0019 64.0793 22.2387 61.4358 26.5539 63.213Z",
    fill: "#BE9CF4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.129 75.2539C13.8664 75.431 14.6653 76.3115 14.9726 76.7296C15.0384 76.8772 15.5783 77.7183 17.2112 79.9023C18.844 82.0863 19.1206 83.4685 19.0547 83.8866C15.947 85.1852 13.6777 83.3455 12.9315 82.2634C11.2986 79.312 12.3828 76.3607 13.129 75.2539Z",
    fill: "#3F3B46"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_399_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10806 85.9081C3.93669 83.0215 8.51718 80.2552 10.7038 79.2329C13.8554 77.4288 16.5732 81.037 14.6742 83.5627C13.155 85.5834 11.0491 87.171 10.1859 87.7122C3.41879 90.7431 2.64771 87.7723 3.10806 85.9081Z",
    fill: "#BE9CF4"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.3809,
    cy: 88.8731,
    rx: 8.03175,
    ry: 10.127,
    fill: "#545258"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4258 20.6416C58.4571 20.0658 54.9048 20.0418 53.2498 20.1018C50.1013 20.081 31.4521 20.7016 26.487 21.1215C21.522 21.5414 21.1587 25.8602 21.1587 26.4C21.1587 26.9399 21.5825 41.9958 21.8247 47.5743C22.0185 52.0371 24.6907 53.4727 26.0026 53.6327C31.4521 54.1126 37.5675 54.3525 43.7436 54.2925C49.9196 54.2325 58.9414 53.0329 59.9102 52.613C60.879 52.1931 63.1799 51.5333 63.6037 47.2744C64.0276 43.0156 63.5432 28.3195 62.8166 25.0804C62.09 21.8413 60.6368 21.3614 59.4258 20.6416Z",
    fill: "#342D40"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.6273,
    cy: 66.1169,
    rx: 3.2243,
    ry: 3.54708,
    transform: "rotate(-25.6356 49.6273 66.1169)",
    fill: "#8256CA"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7346,
    cy: 66.0414,
    rx: 3.05729,
    ry: 3.45629,
    transform: "rotate(-25.6356 49.7346 66.0414)",
    fill: "#A86CFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7274,
    cy: 66.0081,
    rx: 2.63586,
    ry: 3.06899,
    transform: "rotate(-25.6356 49.7274 66.0081)",
    fill: "#8457CD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.6024,
    cy: 66.0911,
    rx: 2.44121,
    ry: 3.06899,
    transform: "rotate(-29.033 49.6024 66.0911)",
    fill: "#7FC4C1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_399_475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 20,
    width: 43,
    height: 35
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4258 20.6416C58.4571 20.0658 54.9048 20.0418 53.2498 20.1018C50.1013 20.081 31.4521 20.7016 26.487 21.1215C21.522 21.5414 21.1587 25.8602 21.1587 26.4C21.1587 26.9399 21.5825 41.9958 21.8247 47.5743C22.0185 52.0371 24.6907 53.4727 26.0026 53.6327C31.4521 54.1126 37.5675 54.3525 43.7436 54.2925C49.9196 54.2325 58.9414 53.0329 59.9102 52.613C60.879 52.1931 63.1799 51.5333 63.6037 47.2744C64.0276 43.0156 63.5432 28.3195 62.8166 25.0804C62.09 21.8413 60.6368 21.3614 59.4258 20.6416Z",
    fill: "#6714EC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_399_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 22.3392L65.1844 20.7777",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4988 23.6986L65.1829 22.1371",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4976 25.0579L65.1817 23.4965",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4959 26.4173L65.18 24.8559",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4947 27.7765L65.1788 26.215",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4932 29.1358L65.1773 27.5744",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4917 30.4952L65.1759 28.9337",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4903 31.8546L65.1744 30.2931",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4888 33.2137L65.1729 31.6523",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4874 34.5731L65.1715 33.0116",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4859 35.9325L65.17 34.371",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4847 37.2918L65.1688 35.7304",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4832 38.651L65.1673 37.0895",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4817 40.0103L65.1659 38.4489",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4803 41.3697L65.1644 39.8083",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4791 42.7291L65.1632 41.1676",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4773 44.0882L65.1615 42.5268",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4761 45.4476L65.1602 43.8861",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4744 46.807L65.1585 45.2455",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4732 48.1663L65.1573 46.6049",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4717 49.5255L65.1558 47.964",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4703 50.8849L65.1544 49.3234",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4688 52.2442L65.1529 50.6828",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4673 53.6036L65.1514 52.0421",
    stroke: "#310E68",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4659 54.9627L65.15 53.4013",
    stroke: "#310E68",
    strokeWidth: 0.5
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.8338,
    cy: 87.205,
    rx: 5.02062,
    ry: 9.0402,
    transform: "rotate(17.44 68.8338 87.205)",
    fill: "#3F3B46"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5398 71.1667C36.2947 72.4166 51.339 73.8665 57.4763 69.6667",
    stroke: "#3F3B46"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1428 74.4161C37.5714 77.3492 51.1904 77.6984 58.1746 73.1587",
    stroke: "#3F3B46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.3811,
    y: 29.4834,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 34.3811 29.4834)",
    fill: "#CCC2DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0393,
    y: 30.9331,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 33.0393 30.9331)",
    fill: "#CCC2DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8308,
    y: 30.8252,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 35.8308 30.8252)",
    fill: "#CCC2DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5073,
    y: 42.5081,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-1.62531 43.5073 42.5081)",
    fill: "#CCC2DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8291,
    y: 43.2258,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-1.62531 42.8291 43.2258)",
    fill: "#CCC2DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9236,
    y: 43.1665,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-1.62531 44.9236 43.1665)",
    fill: "#CCC2DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9678,
    y: 48.1128,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-1.62531 42.9678 48.1128)",
    fill: "#CCC2DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0623,
    y: 48.0535,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-1.62531 45.0623 48.0535)",
    fill: "#CCC2DA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6658,
    y: 48.093,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-1.62531 43.6658 48.093)",
    fill: "#CCC2DA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1506,
    y: 43.9438,
    width: 1.39683,
    height: 4.19048,
    transform: "rotate(-1.62531 42.1506 43.9438)",
    fill: "#CCC2DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9434,
    y: 43.8645,
    width: 1.39683,
    height: 4.19048,
    transform: "rotate(-1.62531 44.9434 43.8645)",
    fill: "#CCC2DA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7346,
    y: 28.8904,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 49.7346 28.8904)",
    fill: "#CCC2DA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3928,
    y: 30.3401,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 48.3928 30.3401)",
    fill: "#CCC2DA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1843,
    y: 30.2322,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.21172 51.1843 30.2322)",
    fill: "#CCC2DA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7976,
    y: 36.4475,
    width: 4.19048,
    height: 4.19048,
    transform: "rotate(-2.84363 33.7976 36.4475)",
    fill: "#CCC2DA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1235,
    y: 34.9829,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 35.1235 34.9829)",
    fill: "#CCC2DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4006,
    y: 40.5632,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 35.4006 40.5632)",
    fill: "#CCC2DA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4719,
    y: 37.9116,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 32.4719 37.9116)",
    fill: "#CCC2DA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0522,
    y: 37.6345,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 38.0522 37.6345)",
    fill: "#CCC2DA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4607,
    y: 35.7151,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 34.4607 35.7151)",
    fill: "#CCC2DA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 33.135,
    y: 37.1794,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 33.135 37.1794)",
    fill: "#CCC2DA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 33.1001,
    y: 36.4819,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 33.1001 36.4819)",
    fill: "#CCC2DA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7632,
    y: 35.7498,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 33.7632 35.7498)",
    fill: "#CCC2DA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 37.251,
    y: 35.5767,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 37.251 35.5767)",
    fill: "#CCC2DA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 37.9832,
    y: 36.2393,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 37.9832 36.2393)",
    fill: "#CCC2DA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1562,
    y: 39.7271,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 38.1562 39.7271)",
    fill: "#CCC2DA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4934,
    y: 40.4592,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 37.4934 40.4592)",
    fill: "#CCC2DA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0056,
    y: 40.6326,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 34.0056 40.6326)",
    fill: "#CCC2DA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2734,
    y: 39.9697,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 33.2734 39.9697)",
    fill: "#CCC2DA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5532,
    y: 35.6111,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 36.5532 35.6111)",
    fill: "#CCC2DA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0176,
    y: 36.937,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 38.0176 36.937)",
    fill: "#CCC2DA"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1216,
    y: 39.0295,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 38.1216 39.0295)",
    fill: "#CCC2DA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7957,
    y: 40.4939,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 36.7957 40.4939)",
    fill: "#CCC2DA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7034,
    y: 40.5979,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 34.7034 40.5979)",
    fill: "#CCC2DA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2388,
    y: 39.2722,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 33.2388 39.2722)",
    fill: "#CCC2DA"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 48.446,
    y: 35.72,
    width: 4.19048,
    height: 4.19048,
    transform: "rotate(-2.84363 48.446 35.72)",
    fill: "#CCC2DA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7717,
    y: 34.2554,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 49.7717 34.2554)",
    fill: "#CCC2DA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 50.0488,
    y: 39.8359,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 50.0488 39.8359)",
    fill: "#CCC2DA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 37.1843,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 47.1201 37.1843)",
    fill: "#CCC2DA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7004,
    y: 36.907,
    width: 1.39683,
    height: 1.39683,
    transform: "rotate(-2.84363 52.7004 36.907)",
    fill: "#CCC2DA"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 49.1089,
    y: 34.9875,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 49.1089 34.9875)",
    fill: "#CCC2DA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7832,
    y: 36.4521,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 47.7832 36.4521)",
    fill: "#CCC2DA"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7483,
    y: 35.7546,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 47.7483 35.7546)",
    fill: "#CCC2DA"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4114,
    y: 35.0225,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 48.4114 35.0225)",
    fill: "#CCC2DA"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8992,
    y: 34.8491,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 51.8992 34.8491)",
    fill: "#CCC2DA"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6313,
    y: 35.512,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 52.6313 35.512)",
    fill: "#CCC2DA"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8044,
    y: 38.9998,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 52.8044 38.9998)",
    fill: "#CCC2DA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1416,
    y: 39.7319,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 52.1416 39.7319)",
    fill: "#CCC2DA"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6541,
    y: 39.9053,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 48.6541 39.9053)",
    fill: "#CCC2DA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9216,
    y: 39.2422,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 47.9216 39.2422)",
    fill: "#CCC2DA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2017,
    y: 34.8838,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 51.2017 34.8838)",
    fill: "#CCC2DA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 52.666,
    y: 36.2095,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 52.666 36.2095)",
    fill: "#CCC2DA"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 52.77,
    y: 38.3022,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 52.77 38.3022)",
    fill: "#CCC2DA"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4441,
    y: 39.7666,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 51.4441 39.7666)",
    fill: "#CCC2DA"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3516,
    y: 39.8706,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 49.3516 39.8706)",
    fill: "#CCC2DA"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 47.887,
    y: 38.5449,
    width: 0.698413,
    height: 0.698413,
    transform: "rotate(-2.84363 47.887 38.5449)",
    fill: "#CCC2DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_399_475",
    x: 58.1746,
    y: 68.9683,
    width: 13.2698,
    height: 13.2698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.0784314 0 0 0 0 0.92549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_399_475"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_399_475",
    x: 3,
    y: 78.7461,
    width: 12.3027,
    height: 10.2664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.0784314 0 0 0 0 0.92549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_399_475"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.2b06210ccf9af5dd8d526b9b51ecee80.svg";
export { ForwardRef as ReactComponent };